module.exports = __webpack_public_path__ + "static/media/testimonials-isabelle.4bceaeef.png";